export default __webpack_public_path__ + "static/media/mask.8c87721f.svg";